import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>,
              next: HttpHandler): Observable<HttpEvent<any>> {

        const access_Token = localStorage.getItem("access_token");

        if (access_Token) {
            const cloned = req.clone({
                headers: req.headers.set("Authorization",
                    "Bearer " + access_Token)
            });

            return next.handle(cloned);
        }
        else {
            return next.handle(req);
        }
    }
}